import { ModalsMapper, createModalsComponent } from 'modules/campaigns/lib';
import { AlertsModalType, ModalProps, useAlertsModalContext } from '../context';
import { AddWebhookModal } from './AddWebhookModal';
import { DeleteWebhookModal } from './DeleteWebhookModal';
import { DisplayWebhookJSONAttributes } from './DisplayWebhookJSONAttributes';
import { EditWebhookModal } from './EditWebhookModal';
import { UpdateAlertsModal } from './UpdateAlertsModal';

const ALERTS_MODAL_COMPONENTS_MAPPER: ModalsMapper<AlertsModalType, any> = {
  [AlertsModalType.UpdateAlertsModal]: UpdateAlertsModal,
  [AlertsModalType.AddWebhookModal]: AddWebhookModal,
  [AlertsModalType.EditWebhookModal]: EditWebhookModal,
  [AlertsModalType.DeleteWebhookModal]: DeleteWebhookModal,
  [AlertsModalType.DisplayWebhookJSONAttributes]: DisplayWebhookJSONAttributes,
};

export const Modals = createModalsComponent<AlertsModalType, ModalProps>(
  ALERTS_MODAL_COMPONENTS_MAPPER,
  useAlertsModalContext,
);
